import isEmpty from 'lodash.isempty';
import isNil from 'lodash.isnil';
import { DEFAULT, CUSTOM } from '../../constants/shared/GraphConstants';
import { getNextPeriod, NA, PERIOD } from '../../constants/shared/CommonConstants';
import { getGoalByMeasureYearGradePeriod } from './filterUtils';

const { EOY, SUMMER } = PERIOD;

/**
 * Get custom and default goal by period and statuses.
 * In case status is present for current period we should take goal for next period.
 * In case current period is EOY and status is present then display NA
 * @param interps. List of all interpretations.
 * @param goals. List of custom goals.
 * @param statuses. List of  student results.
 * @param currentPeriod. Current school period.
 * @param toyPeriods. List of periods.
 * @returns {object} Object  which containse custom gaol, default goal and type
 */
export const getCustomAndDefaultGoalByPeriod = (
    interps,
    goals,
    statuses,
    currentPeriod,
    toyPeriods,
) => {
    const isStatusExist = !isEmpty(statuses.find(status => status.period === currentPeriod));
    const period = !isStatusExist ? currentPeriod : getNextPeriod(currentPeriod, toyPeriods);
    const defaultGoal = getGoalByMeasureYearGradePeriod(interps, null, null, null, period);
    const customGoal = getGoalByMeasureYearGradePeriod(goals, null, null, null, period);
    const isDefaultGoalType = defaultGoal === customGoal || isNil(customGoal);

    return {
        defaultGoal:
            (toyPeriods.length === 3 && currentPeriod === EOY && isStatusExist) ||
            (isStatusExist && currentPeriod === SUMMER)
                ? NA
                : defaultGoal,
        customGoal:
            currentPeriod === SUMMER || (isStatusExist && currentPeriod === EOY) ? NA : customGoal,
        type: isDefaultGoalType ? DEFAULT : CUSTOM,
    };
};

export default getCustomAndDefaultGoalByPeriod;
